import OneLineIndicator from './OneLineIndicator';

export default OneLineIndicator;
